import * as language from "./language";
import Cam from "./camlamp";
import ExportOptions from "./exportoption";
import Dicom from "./dicom";
// import Magecoe from './magecoe'
import Print from "./print";
import LocalServercfg from "./localserver";
import RemoteServer from "./remoteserver";
import GlobalSettings from "./globalsettings";
import Shot from "./topography/ctShotInfo";
import ZernikeParams from "./topography/zernikeParams";
import ZernikeSet from "./topography/zernikeSet";
import MapDraw from "./topography/mapDraw";
import DataShow from "./topography/dataShow";
import ColorBarShown from "./topography/colorBarShown";
import Capture from "./capture";
import Update from "./update";
import WifiCfg from "./wifiCfg";
import RgpPos from "./rgppos";
import ThirdParty from "./thirdparty";
import wifiPwdRecord from "./wifiPwdRecord.js";
import KeratoconusStd from "./keratoconusStd";
import DetectSettings from "./delectsettings.js";
import fileSys from "../fileoprators/fileSystem";
import { isDefined, logStdout } from "../shared/utils";

import { nibutInfrared } from "../fileoprators/license";
import { snlist } from "../shared/consts.js";

window.usbDriver = null;
export const getLanguages = () => language.getLanguages();
window.languages = getLanguages();
// wifiCfg
export const getwifiCfg = () => WifiCfg.getWifiSettings();
window.wifiCfg = getwifiCfg();

export const getwifiPwdRe = () => wifiPwdRecord.getWifiPwd();
window.wifiPwdRecord = getwifiPwdRe();

let globalSettings = new GlobalSettings();
export const saveSettings = (settings) => globalSettings.saveGlobalSettings(settings);
window.settings = globalSettings.getGlobalSettings();
fileSys.muteSound(window.settings.audio.mute);
fileSys.setSound(window.settings.audio.value);

window.snlist = snlist;

window.isNewSN = () => {
  const sn = fileSys.getSN();
  if (!sn) {
    return false;
  } else {
    if (window.snlist.oldRing.includes(sn)) {
      return false;
    } else {
      return true;
    }
  }
};

window.isNewInfrared = () => {
  const sn = fileSys.getSN();
  if (!sn) {
    return false;
  } else {
    if (window.snlist.oldInfrared.includes(sn)) {
      return false;
    } else {
      return true;
    }
  }
};

console.log("---window.isNewSN---", window.isNewSN());
console.log("---window.isNewInfrared---", window.isNewInfrared());

window.loginInfo = fileSys.isLogined();
let cam = new Cam();
export const saveCamSettings = (settings) => cam.saveCamSettings(settings);
window.camSettings = cam.getCamSettings();
window.camSettings.tearheight.filter = 3;
window.camSettings.ocularsurface.cam.mode = 3;
window.camSettings.fbut.cam.mode = 3;
saveCamSettings(window.camSettings);

let exportOptions = new ExportOptions();
export const saveExportOption = (settings) => exportOptions.saveExportSettings(settings);
window.exportOptionSettings = exportOptions.getExportSettings();

window.uploadServer = {
  port: 41234
};

let dicom = new Dicom();
export const saveDicomSettings = (settings) => dicom.saveDicomSettings(settings);
window.dicomSettings = dicom.getDicomSettings();

// let magecoe = new Magecoe()
// export const saveMagCoeSettings = settings => magecoe.saveMagCoeSettings(settings)

let print = new Print();
export const savePrintSettings = (settings) => print.savePrintSettings(settings);
window.printSettings = print.getPrintSettings();
const { printConnection } = window.printSettings;
if (printConnection !== "printer-BOX" && printConnection !== "printer-USB") {
  window.printSettings.printConnection = "printer-USB";
}
let localServerCfg = new LocalServercfg();
export const saveLocalServerSettings = (settings) => localServerCfg.saveServerSettings(settings);
window.localServerSettings = localServerCfg.getServerSettings();

let remoteServer = new RemoteServer();
export const saveServerSettings = (settings) => remoteServer.saveServerSettings(settings);
window.server = remoteServer.getServerSettings();
// 角膜地形设置
let zernikeParams = new ZernikeParams();
export const saveZernikeParams = (settings) => zernikeParams.saveZernikeParamsSettings(settings);
window.zernikeParams = zernikeParams.getSZernikeParamsettings();

let zernikeSet = new ZernikeSet();
export const saveZernikeSetSettings = (settings) => zernikeSet.saveZernikeSetSettings(settings);
window.zernikeSet = zernikeSet.getZernikeSetSettings();
if (isNaN(window.zernikeSet.order)) {
  window.zernikeSet.order = 6;
}
if (isNaN(window.zernikeSet.diameter)) {
  window.zernikeSet.diameter = 9;
}
for (let id = 0; id < window.zernikeParams.params.length; id++) {
  if (id >= ((window.zernikeSet.order + 2) * (window.zernikeSet.order + 1)) / 2) {
    window.zernikeParams.params[id].selected = false;
    window.zernikeParams.params[id].enabled = false;
  }
}

window.zernikeViewParams = {
  maxPeak: { x: -1000, y: -1000 },
  meanRms: { mean: -1000, rms: -1000 }
};

let colorBarShown = new ColorBarShown();
export const saveColorBarShown = (settings) => colorBarShown.saveColorBarShownSettings(settings);
window.colorBarShown = colorBarShown.getColorBarShownSettings();

let mapDraw = new MapDraw();
export const saveMapDrawSettings = (settings) => mapDraw.saveMapDrawSettings(settings);
window.mapDrawSettings = mapDraw.getMapDrawSettings();

let dataShow = new DataShow();
export const saveDataShowSettings = (settings) => dataShow.saveDataShowSettings(settings);
window.dataShowSettings = dataShow.getDataShowSettings();
const rgpPos = new RgpPos();
export const saveRgpPosSettings = (settings) => {
  rgpPos.saveRgpPosSettings(settings);
};
window.rgpPosSettings = rgpPos.getRgpPosSettings();

let shot = new Shot();
export const saveShotInfo = (settings) => shot.saveShotSettings(settings);
export const saveCalibSettings = (settings) => shot.saveCalibSettings(settings);
window.ctShotInfo = shot.getShotSettings();
window.calibSettings = shot.getCalibSettings();
window.ctShotInfo.centerPoint = window.calibSettings.CenterPoint;
window.magecoe = {};
for (let id in window.calibSettings.CenterCamCalib) {
  window.magecoe[id] = parseFloat(window.calibSettings.CenterCamCalib[id]);
}

if (nibutInfrared) {
  window.magecoe.pupilcornea = window.magecoe.pupilcornea_infrared;
  window.calibSettings.CenterCamCalib["nibutInfrared"] = 1;
  shot.saveCalibSettings(window.calibSettings);
}

let capture = new Capture();
export const saveCaptureSettings = (settings) => capture.saveCaptureSettings(settings);
export const getCaptureSettings = () => capture.getCaptureSettings();
window.captureSettings = capture.getCaptureSettings();

let update = new Update();
export const saveUpdateSettings = (settings) => update.saveUpdateSettings(settings);
window.updateSettings = update.getUpdateSettings();

const keratoconusStd = new KeratoconusStd();
export const saveKeratoconusStd = (settings) => {
  keratoconusStd.saveKeratoconusStd(settings);
};
window.keratoconusStd = keratoconusStd.getKeratoconusStd();

const detectSettings = new DetectSettings();
export const saveDelectSettings = (settings) => {
  detectSettings.saveDelectSettings(settings);
};
window.detectSettings = detectSettings.getDelectSettings();

let thirdParty = new ThirdParty();
export const saveThirdPartySettings = (settings) => {
  thirdParty.saveThirdPartySettings(settings);
};
export const initThirdParty = () => {
  let set = thirdParty.getThirdPartySettings();
  if (isDefined(set) && isDefined(window.thirdPartySettings)) {
    logStdout("third party company name", set.company, window.thirdPartySettings);
    if (
      set.company &&
      window.thirdPartySettings.company &&
      set.company.value === window.thirdPartySettings.company.value
    ) {
      window.thirdPartySettings = Object.assign(set, window.thirdPartySettings);
    } else {
      window.thirdPartySettings = set;
    }
    logStdout("third party settings", window.thirdPartySettings);
    saveThirdPartySettings(window.thirdPartySettings);
  } else {
    window.thirdPartySettings = set;
  }
  let result = fileSys.readJsonFile(fileSys.getCalibPath("device.json"));
  if (isDefined(result)) {
    window.SN = result.SN.trim();
  }
  const dirs = fileSys.readDirectory(fileSys.getUtilPath("thirdparty"));
  for (let id in dirs) {
    if (dirs[id].indexOf("index_") >= 0) {
      window.thirdPartySettings = thirdParty.getThirdPartySettings();
      window.thirdpartyScript = window.require(dirs[id]);
      window.thirdpartyScript.init(window.thirdPartySettings, window.SN);
      break;
    }
  }
};
initThirdParty();
const { ip, folder, username, password } = window.settings.sharedFolder || {};
if (isDefined(ip)) {
  if (!window.__main__.debug) {
    fileSys.mountSharedFS([`${ip}/${folder}`, `${username}`, `${password}`], (error) => {
      if (error) logStdout("mount shared fs error:", error.message);
    });
  }
}
export const restoreAllSettings = () => {
  globalSettings.restore();
  dicom.restore();
  dicom.restore();
};



// WEBPACK FOOTER //
// ./src/settings/index.js